module.exports = __webpack_public_path__ + "static/img/shouyetuijian.ef888816.png";